/* "Add matching underlay" tick box on liner product pages (2026-10-03).
   Picks the smallest underlay sheet that covers the selected liner size, keeps it in step
   with variant and quantity changes, and when ticked adds liner + underlay in one click. */
(function () {
  var box = document.querySelector('[data-plxu]');
  var json = document.querySelector('[data-plxu-json]');
  var linerJson = document.querySelector('[data-plxp-json]');
  if (!box || !json || !linerJson) return;
  var grades, liner;
  try { grades = JSON.parse(json.textContent).grades || []; liner = JSON.parse(linerJson.textContent); } catch (e) { return; }
  if (!grades.length || !liner || !liner.variants) return;

  var section = box.closest('section') || document;
  var form = section.querySelector('form[data-type="add-to-cart-form"]') || section.querySelector('product-form form');
  if (!form) return;

  var LABEL = {
    '200': { name: '200gsm heavy-duty', note: 'Recommended' },
    '60': { name: '60gsm lightweight', note: 'Smooth, stone-free ground' }
  };
  var state = { on: false, grade: grades[0].key };
  var current = null; // { v: underlay variant, g: grade, liner: liner variant, qty }

  function money(p) {
    return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function dims(s) {
    var m = String(s || '').match(/(\d+(?:\.\d+)?)\s*m?\s*[x×]\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return { a: Math.max(a, b), b: Math.min(a, b), area: a * b };
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function pretty(s) { return esc(s).replace(/\s*x\s*/i, ' × '); }

  function linerVariant() {
    var input = form.querySelector('[name="id"]');
    var id = input ? +input.value : liner.selected;
    return liner.variants.filter(function (v) { return v.id === id; })[0] || null;
  }
  function linerSize(v) {
    for (var i = 0; i < v.o.length; i++) { if (dims(v.o[i])) return v.o[i]; }
    return null;
  }
  function qty() {
    var q = section.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  // Smallest available sheet that covers the liner either way round; cheapest on a tie.
  function bestFor(g, need) {
    var best = null;
    g.variants.forEach(function (v) {
      if (!v.a) return;
      var d = dims(v.t);
      if (!d || d.a + 1e-6 < need.a || d.b + 1e-6 < need.b) return;
      if (!best || d.area < best.d.area || (d.area === best.d.area && v.p < best.v.p)) best = { v: v, d: d };
    });
    return best;
  }

  function render() {
    var lv = linerVariant();
    var size = lv && linerSize(lv);
    var need = size && dims(size);
    if (!lv || !lv.a || !need) { hide(); return; }

    var opts = [];
    grades.forEach(function (g) { var b = bestFor(g, need); if (b) opts.push({ g: g, v: b.v }); });
    if (!opts.length) { hide(); return; }
    var sel = opts.filter(function (o) { return o.g.key === state.grade; })[0] || opts[0];
    state.grade = sel.g.key;
    var n = qty();
    current = { v: sel.v, g: sel.g, liner: lv, qty: n };

    var lab = LABEL[sel.g.key] || { name: '', note: '' };
    var same = dims(sel.v.t).area === need.area;
    var html =
      '<label class="plxu__main">' +
        '<input type="checkbox" class="plxu__cb" data-plxu-on' + (state.on ? ' checked' : '') + '>' +
        '<span class="plxu__tick" aria-hidden="true"></span>' +
        (sel.g.img ? '<img class="plxu__img" src="' + esc(sel.g.img) + '" width="56" height="56" alt="" loading="lazy">' : '') +
        '<span class="plxu__txt">' +
          '<b>Add matching underlay</b>' +
          '<span><strong>' + pretty(sel.v.t) + '</strong> ' + esc(lab.name) + '. ' +
            (same ? 'Same size as your liner' : 'Covers your ' + pretty(size) + ' liner') +
            ' and guards it against stones and roots.</span>' +
        '</span>' +
        '<span class="plxu__price">+' + money(sel.v.p * n) + (n > 1 ? '<small>' + n + ' × ' + money(sel.v.p) + '</small>' : '') + '</span>' +
      '</label>';
    if (opts.length > 1) {
      html += '<div class="plxu__grades" role="radiogroup" aria-label="Underlay grade">';
      opts.forEach(function (o) {
        var l = LABEL[o.g.key] || { name: o.g.key, note: '' };
        var on = o.g.key === sel.g.key;
        html += '<button type="button" class="plxu__grade' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-plxu-grade="' + esc(o.g.key) + '">' +
          '<span>' + esc(l.name) + '</span><small>' + esc(l.note) + ' · ' + money(o.v.p) + '</small></button>';
      });
      html += '</div>';
    }
    if (state.on) {
      html += '<div class="plxu__total">Liner + underlay: <b>' + money((lv.p + sel.v.p) * n) + '</b></div>';
    }
    box.innerHTML = html;
    box.classList.toggle('is-on', state.on);
    box.hidden = false;
    document.documentElement.classList.toggle('plxu-ticked', state.on);
  }
  function hide() {
    current = null;
    box.hidden = true;
    box.innerHTML = '';
    document.documentElement.classList.remove('plxu-ticked');
  }

  box.addEventListener('change', function (e) {
    if (e.target.matches('[data-plxu-on]')) { state.on = e.target.checked; render(); }
  });
  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-plxu-grade]');
    if (b) { state.grade = b.getAttribute('data-plxu-grade'); state.on = true; render(); }
  });

  // Follow variant and quantity changes.
  section.addEventListener('change', function (e) { if (!box.contains(e.target)) setTimeout(render, 0); });
  section.addEventListener('input', function (e) { if (e.target.name === 'quantity') render(); });
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(render, 0); });
    }
  } catch (e) {}

  // Ticked: add the liner (the theme's own form data) and then the underlay, then go to the basket.
  function showError(msg) {
    var pf = form.closest('product-form') || section;
    var wrap = pf.querySelector('.product-form__error-message-wrapper');
    var el = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && el) { el.textContent = msg; wrap.hidden = false; } else { alert(msg); }
  }
  document.addEventListener('submit', function (e) {
    if (e.target !== form || !state.on || !current) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    render();
    var c = current;
    if (!c) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var spin = form.querySelector('.loading__spinner');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (spin) spin.classList.remove('hidden');
    var done = function () {
      if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
      if (spin) spin.classList.add('hidden');
    };
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function () {
        var q = parseInt(fd.get('quantity'), 10) || 1;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: c.v.id, quantity: q }] })
        }).catch(function () {});
      })
      .then(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; })
      .catch(function (err) {
        done();
        showError((err && (err.description || err.message)) || 'Sorry, that could not be added to your basket. Please try again.');
      });
  }, true);

  render();
})();
